// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      Home: "Home",
      About: "About",
      Services: "Services",
      Contact: "Contact",
      "Advancing Healthcare Through Innovation": "Advancing Healthcare Through Innovation",
      "Designing and developing cutting-edge medical equipment to improve patient care and clinical efficiency.":
        "Designing and developing cutting-edge medical equipment to improve patient care and clinical efficiency.",
      "Discover Our Solutions": "Discover Our Services",
      English: "English",
      Arabic: "Arabic",
Business:"Our Business",




 "opening_hours": {
    "title": "Opening Hours",
    "service": "Support Services",
    "time": "Sat – Thu: 7.00 AM to 4.00 PM",
    "unified": "Unified Number",
    "message": "We are here for you. Contact us via our unified number for your convenience."
  },

///////////////////////////////////////////////////////
  ourServices: "Our Services",
          services: [
            {
              title: "Complete Project Design & Engineering",
              description: "Turnkey hospital project engineering from concept to commissioning.",
            },
            {
              title: "Specialized Solutions - Digital ORs",
              description: "Integrated digital OR design with advanced medical technology.",
            },
            {
              title: "Hospital Networking",
              description: "IT infrastructure and networking tailored for medical environments.",
            },
            {
              title: "MRI Shielding",
              description: "Specialized shielding for MRI and radiology rooms.",
            },
            {
              title: "ICU Pendants",
              description: "Custom ICU pendant systems for critical care units.",
            },
            {
              title: "Dental",
              description: "Complete dental facility planning and equipment supply.",
            },
            {
              title: "Morgues",
              description: "Professional morgue facility design and equipment.",
            }
          ],


//////////////////////////////////////////////////////////
 "ReadMore": "Read More",
      "Close": "Close",
    
 slides: [
       {
      "name": "Medical Furniture",
      "url": "/image/mf.png",
      "description": "From hospital beds and overbed tables to trolleys and examination couches, we offer durable, functional medical furniture. Our designs focus on ergonomics, infection control, and long-term reliability. Perfect for hospitals, clinics, and specialty care units looking for both style and substance."
    },
    {
      "name": "Dental Equipment",
      "url": "/image/da.png",
      "description": "We offer a complete range of dental equipment including dental chairs, imaging systems, and endodontic units. Our solutions are designed to enhance patient comfort, ensure clinician efficiency, and support precise diagnostics. With cutting-edge technology and ergonomic design, we empower dental practices of all sizes."
    },
    {
      "name": "Operation Theater",
      "url": "/image/ot.png",
      "description": "Our operation theater solutions include surgical lights, modular O.R. systems, and digital integration platforms. We provide German and UK-manufactured equipment known for reliability and precision. Designed for complex surgeries, our theaters support safe, sterile, and efficient operating environments."
    },
    {
      "name": "Patient Monitoring",
      "url": "/image/pm.png",
      "description": "Our patient monitoring systems deliver real-time, accurate data on critical vitals such as ECG, SpO2, and blood pressure. Ideal for ICUs, ERs, and wards, they ensure optimal patient safety and timely intervention. Integration capabilities allow seamless connection with hospital networks."
    },
    {
      "name": "Lab Equipment",
      "url": "/image/la.png",
      "description": "We supply advanced laboratory equipment including centrifuges, analyzers, incubators, and more. Designed to meet the needs of clinical diagnostics, research, and quality assurance labs, our equipment ensures high performance, compliance, and reliability in any testing environment."
    },
    {
      "name": "Office And Education Furniture",
      "url": "/image/o.png",
      "description": "Our office and education furniture is designed for modern, flexible environments. We provide desks, chairs, storage, and collaborative solutions that support productivity and learning. Ideal for institutions, training centers, and corporate workspaces aiming for comfort and function."
    },
    {
      "name": "Sterilization",
      "url": "/image/st.png",
      "description": "We deliver turnkey sterilization solutions including autoclaves, washer-disinfectors, and complete CSSD setups. Designed for maximum infection control and regulatory compliance, our systems support hospitals, labs, and clinics in maintaining a sterile and safe healthcare environment."
    },
    {
      "name": "Lab Accessories",
      "url": "/image/le.png",
      "description": "Our range of lab accessories includes precision glassware, safety cabinets, pipettes, and consumables. Built to support routine laboratory tasks, these accessories meet international standards for accuracy and safety. Ideal for educational, research, and diagnostic labs."
    },
    {
      "name": "Surgical & Diagnostic Instruments",
      "url": "/image/s.png",
      "description": "We offer a broad portfolio of surgical and diagnostic instruments for general and specialized procedures. Our products are crafted from high-grade stainless steel, ensuring durability, sharpness, and reliability. Trusted by surgeons and clinicians worldwide."
    },
    {
      "name": "Cold Rooms",
      "url": "/image/cr.png",
      "description": "Our cold room solutions are ideal for preserving vaccines, medicines, and temperature-sensitive samples. With precise temperature control and modular design, they ensure consistent refrigeration in healthcare, research, and pharmaceutical facilities."
    },
    {
      "name": "Emergency Care Solution",
      "url": "/image/emer.png",
      "description": "Our emergency care systems include defibrillators, resuscitation kits, trauma stretchers, and monitoring equipment. Built for high-pressure environments, they support rapid intervention and life-saving care. Essential for ambulances, ERs, and disaster response units."
    },
    {
      "name": "X-Ray",
      "url": "/image/ex.png",
      "description": "Our X-ray systems provide fast, accurate imaging to support emergency diagnoses. Essential in ambulances, ERs, and disaster response units, they help medical teams quickly assess fractures, internal injuries, and critical conditions. Built for high-pressure environments, these systems integrate seamlessly with trauma care equipment to enable rapid, life-saving decisions."
    }
      
      ],


      //////////////////////////////////////////////
  "A": {
    "cards": [
      {
        "title": "Our Mission",
        "text": "Our mission is to create advanced medical technologies that improve patient outcomes and empower healthcare professionals. We are committed to innovation, safety, and precision in every product we design. By combining research, engineering, and compassion, we develop solutions that address real-world medical challenges. Our goal is to make healthcare more effective, accessible, and human-centered across the globe.",
        "image": "/image/Mission.png",
        "backgroundColor": "#CE8238",
        "textColor": "#fff"
      },
      {
        "title": "Our Vision",
        "text": "We envision a world where healthcare is smarter, faster, and more connected through intelligent technology. Our vision is to lead the medical industry with pioneering solutions that redefine how care is delivered. We aim to build a future where our innovations set the standard for global health systems. Through collaboration and bold thinking, we strive to improve lives at every level of care.",
        "image": "/image/Vision.png",
        "backgroundColor": "#0057A4",
        "textColor": "#fff"
      },
      {
        "title": "About Us",
        "text": "We are a global medical technology company dedicated to transforming the future of healthcare. Our team specializes in designing reliable, user-friendly devices that support clinical excellence. We focus on creating tools that assist medical professionals and elevate patient care. At the heart of our work is a commitment to quality, ethics, and continuous innovation.",
        "image": "/image/About.png",
        "backgroundColor": "lightgray",
        "textColor": "black"
      }
    ]
  },
  "Show More": "Read More",
  "Show Less": "Show Less",

///////////////////////////////////////////

 "companyName": "TATWEER MEDICAL CO.",
  "workingHoursHeading": "Working Days & Timings",
  "workingDays": {
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday"
  },
  "workingTimes": {
    "open": "7:00 AM - 4:00 PM",
    "closed": "Closed"
  },


//////////////////////////////////////////

  "footer": {
    "company": "Medical Equipment Development Co., Ltd.",
    "description": "We are a leading innovator in medical technology, providing high-quality equipment to hospitals and healthcare providers worldwide.",
    "contact": "Contact Us",
    "address": "P.O. Box 55093, Riyadh 11534, Kingdom of Saudi Arabia",
    "tel": "Tel",
    "fax": "Fax",
    "cell": "Cell No",
    "email": "Email",
    "vision": "Saudi Vision 2030",
    "copyright": "© 2025 Medical Equipment Development Co., Ltd. All rights reserved."
  },

//////////////////////////////////////////////////////
"heroAbout": {
    "title": "Who we Are"
  },


  ///////////////////////////////////////////////////
"about": {
    "title": "Medical Equipment Development Co., Ltd.",
    "subtitle": "Subsidiary of Al Mansouryah Co. – 35+ years of excellence in Saudi Arabia’s healthcare infrastructure.",
    "legacy": {
      "title": "Our Legacy",
      "description": "Al Mansouryah has delivered several major hospital projects across Saudi Arabia:",
      "projects": [
        "King Fahad Specialist Hospital, Dammam (640 Beds)",
        "Maternity & Pediatric Hospital, Madinah (500 Beds)",
        "Qassim Maternity & Pediatric Hospital (200 Beds)",
        "Al Rass General Hospital (200 Beds)"
      ]
    },
    "ongoing": {
      "title": "Ongoing Projects",
      "desc1": "We’re currently building 354 Primary Health Care Centers across the Kingdom in partnership with the Ministry of Health.",
      "desc2": "All centers will be fully equipped with advanced medical technology provided by us."
    },
    "vision": {
      "title": "Vision",
      "desc": "To become the leading supplier of innovative, reliable medical equipment in the region, improving patient care and hospital outcomes."
    },
    "mission": {
      "title": "Mission",
      "desc": "Deliver high-performance medical technologies and support to elevate healthcare standards, empowering hospitals and clinics nationwide."
    },
    "values": {
      "title": "Core Values",
      "desc": "Integrity. Innovation. Excellence. Customer Commitment. Collaboration. These values drive every project, every interaction, and every decision we make."
    }
  },


  ///////////////////////////////////////////////////////////////////
   "direction": "ltr",
  "Our Business": "Our Business",
  "Medical Equipment Maintenance": "Medical Equipment Maintenance",
  "Ensuring your devices run smoothly...": "Ensuring your devices run smoothly...",
  "Medical Equipment Maintenance Full": "Our expert team ensures that all your medical devices operate safely and efficiently through regular inspections, preventive maintenance, and prompt repairs. We minimize downtime and extend the lifespan of your equipment, complying with industry standards and regulations to guarantee reliable performance in critical healthcare environments.",
  "Medical Equipment Supplying": "Medical Equipment Supplying",
  "High-quality medical devices supplied...": "High-quality medical devices supplied...",
  "Medical Equipment Supplying Full": "We provide a wide range of high-quality medical equipment sourced from trusted manufacturers worldwide. Our supply services include careful selection, procurement, and delivery of devices tailored to meet the specific needs of hospitals, clinics, and healthcare professionals. We ensure timely availability and after-sales support for all supplied products.",
  "Hospital and Clinics Maintenance": "Hospital and Clinics Maintenance",
  "Comprehensive facility upkeep...": "Comprehensive facility upkeep...",
  "Hospital and Clinics Maintenance Full": "We offer comprehensive facility maintenance services designed to keep hospitals and clinics safe, clean, and fully operational. Our skilled technicians manage HVAC systems, electrical installations, plumbing, and building infrastructure with a focus on compliance, hygiene, and patient comfort. This ensures a conducive environment for healthcare delivery and regulatory adherence.",

/////////////////////////////////////////////////////////////////////////
  "s": [
    {
      "title": "ICU Pendants",
      "description": "We supply ceiling-mounted ICU pendant systems that improve space management, staff mobility, and emergency access. Our modular systems feature gas and power outlets, equipment trays, infusion poles, and swivel arms.\n\nWith high load capacity and 360-degree rotation, our pendants support modern ICU workflows while meeting safety and hygiene protocols."
    },
    {
      "title": "Specialized Solutions - Digital ORs",
      "description": "We deliver advanced Digital Operating Rooms (ORs) that integrate surgical light systems, video routing, PACS, ceiling pendants, and touchless control interfaces. Our designs reduce clutter, enhance sterile workflow, and offer intuitive access to surgical data and patient vitals.\n\nWith HD cameras, live-streaming support, centralized control panels, and OR integration management systems (ORIM), our solutions ensure efficiency, hygiene, and operational excellence."
    },
    {
      "title": "Hospital Networking",
      "description": "We design and deploy robust, hospital-grade IT infrastructure, including structured cabling, server rooms, firewalls, access points, and network security.\n\nOur networking services integrate with HIS, PACS, nurse call systems, and BMS. We ensure HIPAA-compliant data protection and real-time communication with zero downtime. Our fiber optic backbone supports large-scale hospital operations and IoMT (Internet of Medical Things) compatibility."
    },
    {
      "title": "MRI Shielding",
      "description": "We provide complete RF and magnetic shielding solutions for MRI suites. This includes RF copper shielding, steel shielding for fringe magnetic fields, waveguide filters for HVAC and power lines, and EMI control.\n\nOur shielding rooms ensure optimal image quality, patient safety, and compliance with OEM installation standards. We also offer shielding verification and post-installation testing to validate attenuation levels."
    },
    {
      "title": "Complete Project Design & Engineering",
      "description": "We provide complete turnkey project design and engineering solutions for hospitals and medical facilities. Our expertise covers architectural layout, structural design, MEP (Mechanical, Electrical & Plumbing) engineering, HVAC systems, fire alarm & suppression, medical gas design, and infection control planning.\n\nFrom feasibility studies and authority approvals to detailed drawings and BOQs, we ensure full compliance with international standards such as FGI, HTM, and NFPA. Our team coordinates all disciplines for seamless integration, eliminating rework and delays."
    },
    {
      "title": "Dental Facilities",
      "description": "We provide full turnkey solutions for dental clinics, including ergonomic layout planning, sterilization zoning, and dental cabinetry. Our packages include dental chairs, X-ray systems, autoclaves, suction units, and air compressors.\n\nWe ensure optimal dentist-patient interaction, staff productivity, and hygienic operation while complying with infection control protocols."
    },
    {
      "title": "Morgues & Autopsy Rooms",
      "description": "We offer complete morgue and autopsy room planning and fit-out services. Our scope includes body refrigerators, stainless steel autopsy tables with drainage, dissection tools, and anti-odor ventilation systems.\n\nWe design for biosafety, infection control, and respectful patient handling. Compliant with WHO and health authority guidelines."
    }
  ],



  ////////////////////////////////////////////////////
 "M": {
    "hero": {
      "title": "Medical Equipment Maintenance",
      "subtitle": "Trusted professionals delivering certified inspection, calibration, and maintenance solutions for all your clinical equipment.",
      "more": {
        "part1": "Our medical equipment maintenance services cover everything from detailed inspections to precise calibrations and timely repairs. We follow stringent regulatory standards to ensure your clinical devices operate reliably and safely.",
        "part2": "Our certified biomedical engineers use state-of-the-art tools and techniques to extend the lifespan of your equipment, minimize downtime, and maintain accuracy. Whether it’s preventive maintenance or urgent repairs, we customize solutions tailored to your facility's needs."
      },
      "buttonShowLess": "Show Less",
      "buttonLearnMore": "Learn More",
      "image": "/image/ME.png"
    },
    
    "services": [
      {
        "title": "Equipment Inspection",
        "desc": "Comprehensive evaluation of medical equipment to ensure optimal performance and safety compliance.",
        "detail": "Our equipment inspection process includes rigorous functional testing, safety checks, and compliance verifications following the latest standards to ensure your devices are always reliable.",
        "image": "/image/inspection.png"
      },
      {
        "title": "Calibration",
        "desc": "Precision calibration services to maintain consistent accuracy across devices.",
        "detail": "We use advanced calibration tools and traceable standards to adjust your equipment accurately, minimizing measurement errors and ensuring operational consistency.",
        "image": "/image/calibration.png"
      },
      {
        "title": "Repair",
        "desc": "Timely repair solutions performed by certified biomedical engineers.",
        "detail": "Our expert engineers handle both hardware and software repairs, using genuine parts and following manufacturer protocols to restore equipment functionality quickly.",
        "image": "/image/repair.png"
      },
      {
        "title": "Preventive Maintenance",
        "desc": "Scheduled maintenance to minimize downtime and extend equipment life cycle.",
        "detail": "Regular preventive maintenance includes cleaning, lubrication, parts replacement, and performance verification to keep your equipment operating smoothly and avoid unexpected failures.",
        "image": "/image/maintenance.png"
      }
    ],
    "servicesTitle": "Our Services",
    "servicesSubtitle": "Explore our full range of maintenance and repair services tailored to meet regulatory standards and ensure operational efficiency."
  },

//////////////////////////////////////////////////////////////////////


"supplier": {
    "heroTitle": "Medical Equipment Supplying",
    "heroDescription": "Trusted supplier of premium medical devices and equipment to healthcare facilities worldwide.",
    "heroLearnMore1": "We specialize in sourcing and delivering a comprehensive range of medical equipment, from diagnostic tools to hospital furniture. Our partnerships with leading manufacturers ensure that you receive the latest technology with certified quality.",
    "heroLearnMore2": "Our dedicated supply chain team works closely with healthcare providers to customize orders, provide training, and offer after-sales support to guarantee smooth integration and optimal use of equipment.",
    "learnMore": "Learn More",
    "showLess": "Show Less",
    "sectionTitle": "Our Supply Categories",
    "sectionDescription": "Discover our diverse range of medical equipment and supplies tailored to meet the needs of modern healthcare providers.",
    "items": [
      {
        "title": "Diagnostic Equipment",
        "description": "High-quality diagnostic devices including ECG, ultrasound, and X-ray machines.",
        "detailedDescription": "We provide a wide range of certified diagnostic equipment designed for accuracy and reliability to help healthcare professionals make precise diagnoses efficiently.",
        "image": "/image/SUP1.png"
      },
      {
        "title": "Surgical Instruments",
        "description": "Sterile and durable surgical tools for all types of procedures.",
        "detailedDescription": "Our surgical instrument supplies include scalpels, forceps, clamps, and more, all sourced from trusted manufacturers to ensure safety and performance in the operating room.",
        "image": "/image/SUP2.png"
      },
      {
        "title": "Patient Monitoring Systems",
        "description": "Advanced monitors to track vital signs and patient status in real-time.",
        "detailedDescription": "Our patient monitoring systems feature cutting-edge technology for continuous observation, helping clinicians respond quickly to patient needs.",
        "image": "/image/SUP3.png"
      },
      {
        "title": "Hospital Furniture",
        "description": "Ergonomic and durable furniture for hospital wards and clinics.",
        "detailedDescription": "We supply beds, chairs, trolleys, and storage solutions designed to improve comfort, functionality, and hygiene in medical environments.",
        "image": "/image/SUP4.png"
      },
      {
        "title": "Laboratory Equipment",
        "description": "State-of-the-art lab instruments including centrifuges, microscopes, and analyzers.",
        "detailedDescription": "Our laboratory equipment range supports accurate testing and research with reliable, calibrated instruments from industry leaders.",
        "image": "/image/SUP5.png"
      },
      {
        "title": "Emergency Equipment",
        "description": "Critical care devices such as defibrillators, ventilators, and emergency carts.",
        "detailedDescription": "We supply essential emergency response equipment designed for rapid deployment and reliability in life-saving situations.",
        "image": "/image/SUP6.png"
      }
    ]
  },

  ///////////////////////////////////

  "hospital": {
    "title": "Hospital and Clinics Maintenance",
    "subtitle": "Reliable and comprehensive maintenance services for healthcare infrastructure and systems.",
    "heroDetail1": "Our maintenance services ensure uninterrupted healthcare operations by taking care of critical systems like HVAC, electrical, plumbing, and medical gas pipelines. We follow industry best practices to meet regulatory compliance.",
    "heroDetail2": "Our skilled engineers and technicians are available for preventive checks, emergency repairs, and scheduled servicing to keep your hospital or clinic running smoothly and safely.",
    "button": {
      "learnMore": "Learn More",
      "showLess": "Show Less"
    },
    "servicesTitle": "Our Maintenance Services",
    "servicesSubtitle": "Explore our specialized facility maintenance services tailored for hospitals and clinics to ensure uninterrupted patient care.",
    "services": [
      {
        "title": "HVAC System Maintenance",
        "description": "Efficient heating, ventilation, and air conditioning system upkeep.",
        "detailed": "We ensure your HVAC systems are regularly inspected, cleaned, and maintained for optimal performance and air quality in healthcare environments."
      },
      {
        "title": "Electrical Maintenance",
        "description": "Reliable maintenance for hospital power systems and equipment.",
        "detailed": "Our team handles routine checks and emergency repairs for electrical systems, ensuring uninterrupted operation of critical medical devices."
      },
      {
        "title": "Medical Gas Pipeline Systems",
        "description": "Secure and compliant gas system checks and servicing.",
        "detailed": "Our certified technicians inspect and maintain pipelines for oxygen, vacuum, and anesthesia gases to ensure consistent and safe delivery."
      },
      {
        "title": "Building & Infrastructure",
        "description": "Structural integrity and safety audits of healthcare facilities.",
        "detailed": "We provide full assessments and maintenance for walls, ceilings, floors, and roofs to uphold safety and cleanliness in medical environments."
      },
      {
        "title": "Equipment Calibration & Testing",
        "description": "Precision testing and calibration of clinical and facility equipment.",
        "detailed": "Our services ensure all hospital machines and tools meet accuracy standards through systematic calibration and performance validation."
      }
    ]
  }

    },
  },
  ar: {
    translation: {
      Home: "الرئيسية",
      About: "من نحن",
      Services: "خدماتنا",
      Contact: "اتصل بنا",
      "Advancing Healthcare Through Innovation": "دفع الرعاية الصحية من خلال الابتكار",
      "Designing and developing cutting-edge medical equipment to improve patient care and clinical efficiency.":
        "تصميم وتطوير معدات طبية متقدمة لتحسين رعاية المرضى وكفاءة العمل السريري.",
      "Discover Our Solutions": "استكشف خدماتنا",
      English: "الإنجليزية",
      Arabic: "العربية",
Business:"أنشطتنا التجارية",




"opening_hours": {
    "title": "ساعات العمل",
    "service": "خدمات الدعم",
    "time": "السبت - الخميس: ٧:٠٠ ص إلى ٤:٠٠ م",
    "unified": "الرقم الموحد",
    "message": "نحن هنا من أجلك. تواصل معنا عبر الرقم الموحد لراحتك."
  },

///////////////////////////////////////////
 ourServices: "خدماتنا",
          services: [
            {
              title: "تصميم وتنفيذ المشاريع الكاملة",
              description: "هندسة مشاريع المستشفيات من المفهوم إلى التسليم الكامل.",
            },
            {
              title: "حلول متخصصة - غرف العمليات الرقمية",
              description: "تصميم غرف عمليات رقمية متكاملة باستخدام تقنيات طبية متقدمة.",
            },
            {
              title: "شبكات المستشفيات",
              description: "بنية تحتية لتقنية المعلومات مخصصة للبيئات الطبية.",
            },
            {
              title: "حماية غرف الرنين المغناطيسي",
              description: "حماية متخصصة لغرف الرنين المغناطيسي والتصوير الشعاعي.",
            },
            {
              title: "أنظمة ICU المعلقة",
              description: "أنظمة ICU مخصصة لوحدات العناية المركزة.",
            },
            {
              title: "الأسنان",
              description: "تخطيط كامل لمنشآت الأسنان وتوريد المعدات.",
            },
            {
              title: "ثلاجات الموتى",
              description: "تصميم مهني لمرافق ثلاجات الموتى وتجهيزها.",
            }
          ],

          //////////////////////////////////////////////////////////////////////
            "ReadMore": "اقرأ المزيد",
      "Close": "إغلاق",
           slides: [
        {
      "name": "الأثاث الطبي",
      "url": "/image/mf.png",
      "description": "من أسرة المستشفيات وطاولات فوق السرير إلى العربات وأرائك الفحص، نقدم أثاثًا طبيًا متينًا وعمليًا. تصاميمنا تركز على الراحة الوظيفية، مكافحة العدوى، والاعتمادية على المدى الطويل. مثالي للمستشفيات والعيادات ووحدات الرعاية المتخصصة التي تبحث عن الجودة والأناقة."
    },
    {
      "name": "معدات طب الأسنان",
      "url": "/image/da.png",
      "description": "نقدم مجموعة كاملة من معدات طب الأسنان تشمل كراسي الأسنان، أنظمة التصوير، ووحدات علاج جذور الأسنان. حلولنا مصممة لتعزيز راحة المريض، ضمان كفاءة الطبيب، ودعم التشخيص الدقيق. مع التكنولوجيا الحديثة والتصميم المريح، ندعم عيادات الأسنان بجميع أحجامها."
    },
    {
      "name": "غرف العمليات",
      "url": "/image/ot.png",
      "description": "تشمل حلول غرف العمليات لدينا أضواء جراحية، أنظمة غرف عمليات معيارية، ومنصات تكامل رقمية. نوفر معدات ألمانية وبريطانية معروفة بالاعتمادية والدقة. مصممة للجراحات المعقدة، تدعم غرفنا بيئات تشغيل آمنة، معقمة، وفعالة."
    },
    {
      "name": "مراقبة المرضى",
      "url": "/image/pm.png",
      "description": "أنظمة مراقبة المرضى لدينا توفر بيانات دقيقة وفورية عن العلامات الحيوية المهمة مثل تخطيط القلب، نسبة الأكسجين في الدم، وضغط الدم. مثالية لوحدات العناية المركزة، غرف الطوارئ، والأقسام، لضمان سلامة المرضى والتدخل السريع. تدعم التكامل مع شبكات المستشفيات بسلاسة."
    },
    {
      "name": "معدات المختبر",
      "url": "/image/la.png",
      "description": "نوفر معدات مختبر متقدمة تشمل أجهزة الطرد المركزي، المحللات، الحاضنات، وأكثر. مصممة لتلبية احتياجات التشخيصات السريرية، البحث، ومختبرات ضمان الجودة، تضمن معداتنا أداء عالي، التزام بالمعايير، وموثوقية في أي بيئة اختبار."
    },
    {
      "name": "أثاث المكاتب والتعليم",
      "url": "/image/o.png",
      "description": "أثاث المكاتب والتعليم لدينا مصمم للبيئات الحديثة والمرنة. نقدم مكاتب، كراسي، خزائن، وحلول تعاون تدعم الإنتاجية والتعلم. مثالي للمؤسسات، مراكز التدريب، ومساحات العمل المؤسسية التي تهدف إلى الراحة والوظيفة."
    },
    {
      "name": "التعقيم",
      "url": "/image/st.png",
      "description": "نقدم حلول تعقيم متكاملة تشمل الأوتوكلافات، أجهزة الغسيل والتعقيم، وأنظمة CSSD كاملة. مصممة لأقصى درجات مكافحة العدوى والالتزام التنظيمي، تدعم أنظمتنا المستشفيات، المختبرات، والعيادات في الحفاظ على بيئة صحية معقمة وآمنة."
    },
    {
      "name": "ملحقات المختبر",
      "url": "/image/le.png",
      "description": "تشمل ملحقات المختبر لدينا أدوات زجاجية دقيقة، خزائن أمان، ماصات، ومواد استهلاكية. مصممة لدعم مهام المختبر الروتينية، تلبي هذه الملحقات المعايير الدولية للدقة والسلامة. مثالية للمختبرات التعليمية والبحثية والتشخيصية."
    },
    {
      "name": "الأدوات الجراحية والتشخيصية",
      "url": "/image/s.png",
      "description": "نقدم مجموعة واسعة من الأدوات الجراحية والتشخيصية للإجراءات العامة والمتخصصة. منتجاتنا مصنوعة من الفولاذ المقاوم للصدأ عالي الجودة، مما يضمن المتانة، الحدة، والموثوقية. موثوقة من قبل الجراحين والأطباء حول العالم."
    },
    {
      "name": "غرف التبريد",
      "url": "/image/cr.png",
      "description": "حلول غرف التبريد لدينا مثالية لحفظ اللقاحات، الأدوية، والعينات الحساسة للحرارة. مع تحكم دقيق في الحرارة وتصميم معياري، تضمن تبريدًا مستمرًا في مرافق الرعاية الصحية، البحث، والصيدلة."
    },
    {
      "name": "حلول العناية الطارئة",
      "url": "/image/emer.png",
      "description": "تشمل أنظمة العناية الطارئة لدينا مزيلات الرجفان، أطقم الإنعاش، نقالات الإصابات، وأجهزة المراقبة. مصممة لبيئات الضغط العالي، تدعم التدخل السريع والرعاية المنقذة للحياة. أساسية لسيارات الإسعاف، غرف الطوارئ، ووحدات الاستجابة للكوارث."
    },
    {
      "name": "الأشعة السينية",
      "url": "/image/ex.png",
      "description": "أنظمة الأشعة السينية لدينا توفر تصويرًا سريعًا ودقيقًا لدعم التشخيصات الطارئة. ضرورية في سيارات الإسعاف، غرف الطوارئ، ووحدات الاستجابة للكوارث، تساعد الفرق الطبية على تقييم الكسور، الإصابات الداخلية، والحالات الحرجة بسرعة. مصممة لبيئات الضغط العالي، تتكامل بسلاسة مع معدات رعاية الإصابات لتمكين قرارات سريعة ومنقذة للحياة."
    },

    
    
  
      ],

///////////////////////////////////////////////
  "A": {
    "cards": [
      {
        "title": "مهمتنا",
        "text": "مهمتنا هي تطوير تقنيات طبية متقدمة تُحسِّن نتائج المرضى وتُسهِّل عمل المتخصصين في الرعاية الصحية. نحن ملتزمون بالابتكار والسلامة والدقة في كل منتج نقوم بتصميمه. من خلال الجمع بين البحث والهندسة والرحمة، نطور حلولاً تُعالج تحديات طبية حقيقية. هدفنا هو جعل الرعاية الصحية أكثر فاعلية وإتاحة وإنسانية في جميع أنحاء العالم.",
        "image": "/image/Mission.png",
        "backgroundColor": "#CE8238",
        "textColor": "#fff"
      },
      {
        "title": "رؤيتنا",
        "text": "نحن نتصور عالماً تصبح فيه الرعاية الصحية أكثر ذكاءً وسرعة واتصالاً من خلال التكنولوجيا الذكية. رؤيتنا هي قيادة الصناعة الطبية بحلول مبتكرة تُعيد تعريف كيفية تقديم الرعاية. نهدف إلى بناء مستقبل تصبح فيه ابتكاراتنا معياراً في الأنظمة الصحية العالمية. من خلال التعاون والتفكير الجريء، نسعى لتحسين الحياة على جميع مستويات الرعاية.",
        "image": "/image/Vision.png",
        "backgroundColor": "#0057A4",
        "textColor": "#fff"
      },
      {
        "title": "من نحن",
        "text": "نحن شركة تكنولوجيا طبية عالمية مكرسة لتحويل مستقبل الرعاية الصحية. فريقنا متخصص في تصميم أجهزة موثوقة وسهلة الاستخدام تدعم التميز السريري. نركز على إنشاء أدوات تساعد المتخصصين الطبيين وتُحسِّن رعاية المرضى. في صميم عملنا التزام بالجودة والأخلاقيات والابتكار المستمر.",
        "image": "/image/About.png",
        "backgroundColor": "lightgray",
        "textColor": "black"
      }
    ]
  },
  "Who We Are": "من نحن",
  "Show More": "اقرأ المزيد",
  "Show Less": "عرض أقل",


////////////////////////////////////////
 "companyName": "شركة تطوير الطبية",
  "workingHoursHeading": "أيام وساعات العمل",
  "workingDays": {
    "Saturday": "السبت",
    "Sunday": "الأحد",
    "Monday": "الإثنين",
    "Tuesday": "الثلاثاء",
    "Wednesday": "الأربعاء",
    "Thursday": "الخميس",
    "Friday": "الجمعة"
  },
  "workingTimes": {
    "open": "٧:٠٠ ص - ٤:٠٠ م",
    "closed": "مغلق"
  },

///////////////////////////////////////////////////
"footer": {
    "company": "شركة تطوير المعدات الطبية المحدودة",
    "description": "نحن شركة رائدة في مجال التكنولوجيا الطبية، نقدم معدات عالية الجودة للمستشفيات ومقدمي الرعاية الصحية في جميع أنحاء العالم.",
    "contact": "تواصل معنا",
    "address": "ص.ب 55093، الرياض 11534، المملكة العربية السعودية",
    "tel": "هاتف",
    "fax": "فاكس",
    "cell": "جوال",
    "email": "البريد الإلكتروني",
    "vision": "رؤية السعودية 2030",
    "copyright": "© 2025 شركة تطوير المعدات الطبية المحدودة. جميع الحقوق محفوظة."
  },
  /////////////////////////////////////
  "heroAbout": {
    "title": "من نحن"
  },

////////////////////////////////////////////////////////
"about": {
    "title": "شركة تطوير المعدات الطبية المحدودة",
    "subtitle": "شركة تابعة لشركة المنصورية – أكثر من 35 عامًا من التميز في البنية التحتية للرعاية الصحية في المملكة العربية السعودية.",
    "legacy": {
      "title": "إرثنا",
      "description": "قامت شركة المنصورية بتنفيذ العديد من المشاريع الكبرى للمستشفيات في جميع أنحاء المملكة:",
      "projects": [
        "مستشفى الملك فهد التخصصي، الدمام (640 سريرًا)",
        "مستشفى النساء والولادة والأطفال، المدينة المنورة (500 سرير)",
        "مستشفى النساء والولادة والأطفال، القصيم (200 سرير)",
        "مستشفى الرس العام (200 سرير)"
      ]
    },
    "ongoing": {
      "title": "المشاريع الجارية",
      "desc1": "نقوم حاليًا بإنشاء 354 مركز رعاية صحية أولية في جميع أنحاء المملكة بالشراكة مع وزارة الصحة.",
      "desc2": "جميع المراكز ستكون مجهزة بالكامل بأحدث التقنيات الطبية التي نوفرها."
    },
    "vision": {
      "title": "رؤيتنا",
      "desc": "أن نكون المورد الرائد للمعدات الطبية المبتكرة والموثوقة في المنطقة، مما يساهم في تحسين رعاية المرضى ونتائج المستشفيات."
    },
    "mission": {
      "title": "مهمتنا",
      "desc": "تقديم تقنيات طبية عالية الأداء ودعم شامل لرفع معايير الرعاية الصحية، وتمكين المستشفيات والعيادات في جميع أنحاء المملكة."
    },
    "values": {
      "title": "قيمنا الأساسية",
      "desc": "النزاهة. الابتكار. التميز. الالتزام بالعملاء. التعاون. هذه القيم تقود كل مشروع، وكل تفاعل، وكل قرار نتخذه."
    }
  },

  ///////////////////////////////////////////

  "direction": "rtl",
  "Our Business": "أعمالنا",
  "Medical Equipment Maintenance": "صيانة المعدات الطبية",
  "Ensuring your devices run smoothly...": "ضمان تشغيل أجهزتكم بسلاسة...",
  "Medical Equipment Maintenance Full": "يضمن فريقنا المختص تشغيل جميع أجهزتكم الطبية بأمان وكفاءة من خلال عمليات الفحص الدورية، الصيانة الوقائية، والإصلاحات السريعة. نعمل على تقليل فترات التوقف وزيادة عمر المعدات مع الالتزام بمعايير الصناعة واللوائح لضمان أداء موثوق في بيئات الرعاية الصحية الحيوية.",
  "Medical Equipment Supplying": "توريد المعدات الطبية",
  "High-quality medical devices supplied...": "توريد أجهزة طبية عالية الجودة...",
  "Medical Equipment Supplying Full": "نوفر مجموعة واسعة من المعدات الطبية عالية الجودة من مصنعين موثوقين حول العالم. تشمل خدمات التوريد اختيارًا دقيقًا، شراءً وتسليمًا لأجهزة تلبي احتياجات المستشفيات والعيادات والمتخصصين في الرعاية الصحية. نضمن توفر المعدات في الوقت المناسب مع دعم ما بعد البيع لجميع المنتجات.",
  "Hospital and Clinics Maintenance": "صيانة المستشفيات والعيادات",
  "Comprehensive facility upkeep...": "صيانة شاملة للمرافق...",
  "Hospital and Clinics Maintenance Full": "نقدم خدمات صيانة شاملة للمرافق تهدف إلى الحفاظ على سلامة ونظافة وعملية المستشفيات والعيادات. يدير فنينا المهرة أنظمة التدفئة والتهوية وتكييف الهواء، التركيبات الكهربائية، السباكة، وبنية المباني مع التركيز على الامتثال، النظافة، وراحة المرضى. مما يضمن بيئة ملائمة لتقديم الرعاية الصحية والالتزام التنظيمي.",
///////////////////////////////////////////////////////////////////


  "s": [
    {
      "title": "وحدات تعليق العناية المركزة",
      "description": "نقدم وحدات تعليق سقفية للعناية المركزة تُحسن إدارة المساحة، وسهولة حركة الطاقم، وسرعة الوصول في حالات الطوارئ. أنظمتنا المعيارية تتضمن منافذ غاز وكهرباء، صواني معدات، أعمدة تسريب، وأذرع دوارة.\n\nبفضل قدرتها العالية على التحمل ودوران 360 درجة، تدعم وحداتنا سير العمل الحديث في وحدات العناية المركزة مع الالتزام الكامل بمعايير السلامة والنظافة."
    },
    {
      "title": "الحلول المتخصصة - غرف العمليات الرقمية",
      "description": "نقدم غرف عمليات رقمية متطورة تدمج أنظمة الإضاءة الجراحية، توجيه الفيديو، PACS، وحدات تعليق السقف، وواجهات تحكم بدون لمس. تصاميمنا تقلل الفوضى وتعزز سير العمل المعقم وتوفر وصولاً سهلاً إلى بيانات الجراحة وبيانات المريض الحيوية.\n\nمع كاميرات عالية الدقة، دعم البث المباشر، لوحات تحكم مركزية، وأنظمة إدارة تكامل غرف العمليات (ORIM)، تضمن حلولنا الكفاءة، والنظافة، والتميز التشغيلي."
    },
    {
      "title": "شبكات المستشفيات",
      "description": "نقوم بتصميم وتنفيذ بنية تحتية قوية لتكنولوجيا المعلومات للمستشفيات، تشمل الكابلات المنظمة، غرف السيرفرات، الجدران النارية، نقاط الوصول، وأمن الشبكات.\n\nتتكامل خدماتنا الشبكية مع أنظمة HIS، PACS، نداء الممرضات، وأنظمة إدارة المباني. نضمن حماية بيانات متوافقة مع HIPAA واتصال في الوقت الفعلي بدون توقف. يدعم العمود الفقري الليفي لدينا العمليات الكبيرة وتوافق الإنترنت للأجهزة الطبية (IoMT)."
    },
    {
      "title": "تدريع أجهزة الرنين المغناطيسي",
      "description": "نقدم حلول تدريع كاملة للترددات اللاسلكية والمجالات المغناطيسية لغرف الرنين المغناطيسي، بما في ذلك تدريع بالنحاس للترددات، تدريع فولاذي للحقول المغناطيسية المحيطية، فلاتر الموجات للتهوية والكهرباء، والتحكم في التداخل الكهرومغناطيسي.\n\nتوفر غرف التدريع جودة صورة مثالية، وسلامة المرضى، والامتثال لمعايير تركيب الشركات المصنعة. كما نقدم اختبارات تحقق بعد التركيب لقياس مستويات التوهين."
    },
    {
      "title": "تصميم وتنفيذ المشاريع الكاملة",
      "description": "نقدم حلول تصميم وتنفيذ مشاريع شاملة للمستشفيات والمرافق الطبية. تغطي خبرتنا التخطيط المعماري، التصميم الإنشائي، هندسة الميكانيكا والكهرباء والسباكة (MEP)، أنظمة التكييف، أنظمة الحريق، تصميم الغازات الطبية، وتخطيط مكافحة العدوى.\n\nمن دراسات الجدوى والموافقات الرسمية إلى الرسومات التفصيلية وجداول الكميات، نضمن الامتثال الكامل للمعايير الدولية مثل FGI، HTM، وNFPA. ينسق فريقنا بين جميع التخصصات لتحقيق تكامل سلس وتجنب إعادة العمل أو التأخير."
    },
    {
      "title": "عيادات الأسنان",
      "description": "نوفر حلولاً متكاملة لعيادات الأسنان تشمل تخطيط التخطيط المريح، مناطق التعقيم، وخزائن الأسنان. تتضمن باقاتنا كراسي الأسنان، أنظمة الأشعة، أجهزة التعقيم، وحدات الشفط، وضواغط الهواء.\n\nنضمن تفاعلًا مثاليًا بين الطبيب والمريض، وفعالية للطاقم، وتشغيل صحي متوافق مع بروتوكولات مكافحة العدوى."
    },
    {
      "title": "ثلاجات الموتى وغرف التشريح",
      "description": "نقدم تخطيطًا وتجهيزًا كاملاً لغرف التشريح وثلاجات الموتى، يشمل ثلاجات الجثث، طاولات تشريح من الفولاذ المقاوم للصدأ مع تصريف، أدوات تشريح، وأنظمة تهوية مضادة للروائح.\n\nنصمم بما يضمن السلامة البيولوجية، ومكافحة العدوى، والتعامل المحترم مع الجثث. متوافق مع إرشادات منظمة الصحة العالمية والهيئات الصحية."
    }
  ],
////////////////////////////////////////////
 "M": {
    "hero": {
      "title": "صيانة الأجهزة الطبية",
      "subtitle": "مهنيون موثوقون يقدمون خدمات الفحص المعتمدة والمعايرة والصيانة لجميع معداتك الطبية.",
      "more": {
        "part1": "تشمل خدمات صيانة الأجهزة الطبية لدينا كل شيء من الفحوصات التفصيلية إلى المعايرات الدقيقة والإصلاحات في الوقت المناسب. نتبع معايير تنظيمية صارمة لضمان عمل أجهزتك السريرية بشكل موثوق وآمن.",
        "part2": "يستخدم مهندسونا الطبيون المعتمدون أحدث الأدوات والتقنيات لتمديد عمر معداتك، وتقليل فترة التوقف، والحفاظ على الدقة. سواء كانت صيانة وقائية أو إصلاحات عاجلة، فإننا نقدم حلولاً مخصصة تناسب احتياجات منشأتك."
      },
      "buttonShowLess": "عرض أقل",
      "buttonLearnMore": "المزيد",
      "image": "/image/ME.png"
    },
    "services": [
      {
        "title": "فحص الأجهزة",
        "desc": "تقييم شامل للأجهزة الطبية لضمان الأداء الأمثل والامتثال لمعايير السلامة.",
        "detail": "يشمل عملية فحص الأجهزة لدينا اختبارات وظيفية دقيقة، وفحوصات السلامة، والتحقق من الامتثال لأحدث المعايير لضمان موثوقية أجهزتك دائمًا.",
        "image": "/image/inspection.png"
      },
      {
        "title": "المعايرة",
        "desc": "خدمات معايرة دقيقة للحفاظ على الاتساق في دقة الأجهزة.",
        "detail": "نستخدم أدوات معايرة متقدمة ومعايير قابلة للتتبع لضبط أجهزتك بدقة، وتقليل أخطاء القياس، وضمان الاتساق التشغيلي.",
        "image": "/image/calibration.png"
      },
      {
        "title": "الإصلاح",
        "desc": "حلول إصلاح في الوقت المناسب تتم بواسطة مهندسين طبيين معتمدين.",
        "detail": "يتولى مهندسونا الخبراء إصلاحات الأجهزة والبرامج، باستخدام قطع غيار أصلية واتباع بروتوكولات المصنع لاستعادة وظيفة الجهاز بسرعة.",
        "image": "/image/repair.png"
      },
      {
        "title": "الصيانة الوقائية",
        "desc": "صيانة مجدولة لتقليل التوقف وتمديد دورة حياة الجهاز.",
        "detail": "تشمل الصيانة الوقائية الدورية التنظيف، والتشحيم، واستبدال الأجزاء، والتحقق من الأداء للحفاظ على تشغيل أجهزتك بسلاسة وتجنب الأعطال المفاجئة.",
        "image": "/image/maintenance.png"
      }
    ],
    "servicesTitle": "خدماتنا",
    "servicesSubtitle": "استكشف مجموعتنا الكاملة من خدمات الصيانة والإصلاح المصممة لتلبية المعايير التنظيمية وضمان الكفاءة التشغيلية."
  },


//////////////////////////////////////////////////////
"supplier": {
    "heroTitle": "توريد المعدات الطبية",
    "heroDescription": "مورد موثوق للأجهزة والمعدات الطبية عالية الجودة لمرافق الرعاية الصحية حول العالم.",
    "heroLearnMore1": "نحن متخصصون في توفير مجموعة شاملة من المعدات الطبية، من أدوات التشخيص إلى أثاث المستشفيات. شراكاتنا مع الشركات الرائدة تضمن حصولكم على أحدث التقنيات مع جودة معتمدة.",
    "heroLearnMore2": "يعمل فريق سلسلة التوريد لدينا عن كثب مع مقدمي الرعاية الصحية لتخصيص الطلبات، وتوفير التدريب، ودعم ما بعد البيع لضمان التكامل السلس والاستخدام الأمثل للمعدات.",
    "learnMore": "عرض المزيد",
    "showLess": "عرض أقل",
    "sectionTitle": "فئات التوريد لدينا",
    "sectionDescription": "استكشف مجموعتنا المتنوعة من المعدات والإمدادات الطبية المصممة لتلبية احتياجات مقدمي الرعاية الصحية الحديثة.",
    "items": [
      {
        "title": "معدات التشخيص",
        "description": "أجهزة تشخيص عالية الجودة تشمل أجهزة ECG والموجات فوق الصوتية وأشعة إكس.",
        "detailedDescription": "نقدم مجموعة واسعة من معدات التشخيص المعتمدة المصممة لتحقيق الدقة والموثوقية لمساعدة المتخصصين في الرعاية الصحية على إجراء التشخيصات بدقة وكفاءة.",
        "image": "/image/SUP1.png"
      },
      {
        "title": "الأدوات الجراحية",
        "description": "أدوات جراحية معقمة ومتينة لجميع أنواع العمليات.",
        "detailedDescription": "تشمل إمداداتنا من الأدوات الجراحية المشارط والملقط والمشابك والمزيد، وكلها من مصادر موثوقة لضمان السلامة والكفاءة في غرف العمليات.",
        "image": "/image/SUP2.png"
      },
      {
        "title": "أنظمة مراقبة المرضى",
        "description": "أجهزة مراقبة متقدمة لتتبع العلامات الحيوية وحالة المرضى في الوقت الفعلي.",
        "detailedDescription": "تتميز أنظمتنا بمراقبة المرضى بأحدث التقنيات للمراقبة المستمرة، مما يساعد الأطباء على الاستجابة السريعة لاحتياجات المرضى.",
        "image": "/image/SUP3.png"
      },
      {
        "title": "أثاث المستشفيات",
        "description": "أثاث مريح ومتين لأجنحة المستشفيات والعيادات.",
        "detailedDescription": "نقوم بتوريد الأسرة والكراسي والعربات وحلول التخزين المصممة لتحسين الراحة والوظائف والنظافة في البيئات الطبية.",
        "image": "/image/SUP4.png"
      },
      {
        "title": "معدات المختبرات",
        "description": "أجهزة مختبر متقدمة تشمل أجهزة الطرد المركزي والمجاهر والمحليلات.",
        "detailedDescription": "تدعم معدات المختبرات الخاصة بنا الاختبارات الدقيقة والبحوث من خلال أجهزة موثوقة ومعايرة من أبرز الشركات.",
        "image": "/image/SUP5.png"
      },
      {
        "title": "معدات الطوارئ",
        "description": "أجهزة الرعاية الحرجة مثل أجهزة إزالة الرجفان وأجهزة التنفس وعربات الطوارئ.",
        "detailedDescription": "نوفر معدات الاستجابة للطوارئ الأساسية المصممة للنشر السريع والموثوقية في حالات إنقاذ الحياة.",
        "image": "/image/SUP6.png"
      }
    ]
  }
,
//////////////////////////////////////////////////////////////
"hospital": {
    "title": "صيانة المستشفيات والعيادات",
    "subtitle": "خدمات صيانة موثوقة وشاملة للبنية التحتية والأنظمة الصحية.",
    "heroDetail1": "تضمن خدمات الصيانة لدينا استمرارية عمل مرافق الرعاية الصحية من خلال العناية بالأنظمة الحيوية مثل التكييف والكهرباء والسباكة وأنظمة الغازات الطبية. نحن نتبع أفضل الممارسات لتحقيق الامتثال للمعايير التنظيمية.",
    "heroDetail2": "مهندسونا وفنيونا المهرة متاحون لإجراء الفحوصات الوقائية والإصلاحات الطارئة والصيانة المجدولة لضمان عمل المستشفيات والعيادات بسلاسة وأمان.",
    "button": {
      "learnMore": "اعرف المزيد",
      "showLess": "عرض أقل"
    },
    "servicesTitle": "خدمات الصيانة لدينا",
    "servicesSubtitle": "اكتشف خدمات صيانة المرافق المتخصصة المصممة للمستشفيات والعيادات لضمان رعاية صحية مستمرة.",
    "services": [
      {
        "title": "صيانة نظام التكييف",
        "description": "صيانة فعالة لأنظمة التدفئة والتهوية وتكييف الهواء.",
        "detailed": "نضمن فحص وتنظيف وصيانة أنظمة التكييف بانتظام للحصول على أداء مثالي وجودة هواء عالية في بيئات الرعاية الصحية."
      },
      {
        "title": "الصيانة الكهربائية",
        "description": "صيانة موثوقة لأنظمة الطاقة والمعدات الطبية.",
        "detailed": "يتولى فريقنا الفحوصات الروتينية والإصلاحات الطارئة لأنظمة الكهرباء لضمان عمل الأجهزة الطبية الحيوية دون انقطاع."
      },
      {
        "title": "أنظمة أنابيب الغازات الطبية",
        "description": "فحوصات وصيانة آمنة ومتوافقة لأنظمة الغازات.",
        "detailed": "يقوم فنيونا المعتمدون بفحص وصيانة خطوط الأكسجين والشفط وغازات التخدير لضمان توصيل آمن وثابت."
      },
      {
        "title": "البنية التحتية للمبنى",
        "description": "تدقيقات للسلامة وسلامة الهيكل في المرافق الصحية.",
        "detailed": "نقوم بإجراء تقييمات شاملة وصيانة للجدران والأسقف والأرضيات والأسطح لضمان النظافة والسلامة في البيئات الطبية."
      },
      {
        "title": "معايرة واختبار المعدات",
        "description": "اختبار دقيق ومعايرة للمعدات السريرية والمرافق.",
        "detailed": "نضمن دقة أداء أجهزة المستشفى من خلال عمليات المعايرة المنتظمة والتحقق من الأداء."
      }
    ]
  }

    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
